// extracted by mini-css-extract-plugin
module.exports = {"SQuoteContainer":"Quote_SQuoteContainer__Jvg6b","SQuoteText":"Quote_SQuoteText__R6Ljr","SQuoteSource":"Quote_SQuoteSource__ZvWXN"};